import { render, staticRenderFns } from "./Resposta.vue?vue&type=template&id=1f8213ee"
import script from "./Resposta.vue?vue&type=script&lang=js"
export * from "./Resposta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports